import React, { useState } from 'react';
import styles from './PopupEventNotice.module.scss';
import Icon from '../Icon';
import Button from '../Button/Button';
import { useTranslation } from 'next-i18next';

const PopupEventNotice = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);

    const closePopup = () => {
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <div className={styles['PopupEventNotice']} onClick={closePopup}>
            <div
                className={styles['PopupEventNotice__Container']}
                onClick={(e) => e.stopPropagation()}>
                <button
                    className={styles['PopupEventNotice__CloseButton']}
                    onClick={closePopup}>
                    <Icon size="medium" type="close" color="black" />
                </button>
                <div className={styles['PopupEventNotice__IconWrapper']}>
                    <Icon size="xl" type="error" color="black" />
                </div>
                <span className={styles['PopupEventNotice__Title']}>
                    {t('PopupEventNotice.title')}
                </span>
                <span className={styles['PopupEventNotice__Text']}>
                    {t('PopupEventNotice.text')}
                </span>
                <Button
                    type="primary"
                    text={t('PopupEventNotice.button')}
                    onClick={closePopup}
                    buttonColor="pink"
                    size="medium"
                />
            </div>
        </div>
    );
};

export default PopupEventNotice;
